import { WalletCustody } from '@capsicum/common';
import { usePartners } from '@capsicum/socios-core';
import { useCallback } from 'react';

import { useMyCollectiblesQuery } from '../data-access/queries';
import { type MyCollectible } from '../models';
import { mapPartnerToCollectiblePartner } from '../util';

/**
 * @param partnerId
 * @returns user's collectibles filtered by partner
 */
export const useMyCollectiblesByPartner = (partnerId: string) => {
	const { getPartnerBy } = usePartners();

	return useMyCollectiblesQuery(
		useCallback(
			(data): Array<MyCollectible> | undefined =>
				data
					?.filter(collectible => collectible?.summary?.references?.partnerId === partnerId)
					?.reduce((myCollectibles, collectible) => {
						const partnerId = collectible?.summary?.references?.partnerId;
						const partner = getPartnerBy(p => p.id === partnerId);

						const myCollectible: MyCollectible = {
							...collectible,
							partner: mapPartnerToCollectiblePartner(partner)
						};

						myCollectibles.push(myCollectible);

						return myCollectibles;
					}, [] as Array<MyCollectible>),
			[getPartnerBy, partnerId]
		),
		{
			direction: 'desc',
			orderBy: 'createdAt',
			//TODO: hardcoded value - in current implementation partner wallet page is always custodial. Should be revisited in the future
			walletCustody: WalletCustody.Custodial
		}
	);
};
